import { render, staticRenderFns } from "./PxTable.vue?vue&type=template&id=077f7077&scoped=true&"
import script from "./PxTable.vue?vue&type=script&lang=js&"
export * from "./PxTable.vue?vue&type=script&lang=js&"
import style0 from "./PxTable.vue?vue&type=style&index=0&id=077f7077&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "077f7077",
  null
  
)

export default component.exports